import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import debounce from "lodash/debounce";
import { useParams } from "react-router-dom";
import "../../css/empresa_uno/product.css";
import "../../css/table.css";
import { toast } from "react-toastify";
import { throttle } from "lodash";

import buscar_azul from "../../images/search_azul.png";
import { Preloader } from "../../components/Preloader";
import {
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	Container,
	Typography,
	Stack,
	Alert,
	Tooltip,
	Menu,
	Button as MuiButton,
	IconButton as MuiIcon,
} from "@mui/material";
import imgDefault from "../../images/img_default.png";
import { ApiService } from "../../components/ApiService";

import { ExpandMore, LocalShipping, UploadFile, PictureAsPdf } from "@mui/icons-material";
import RefreshIcon from '@mui/icons-material/Refresh';
import RemoveRedEyeRoundedIcon from "@mui/icons-material/RemoveRedEyeRounded";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityOffRoundedIcon from "@mui/icons-material/VisibilityOffRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import Snackbar from "@mui/material/Snackbar";
import SendProducts from "../../components/empresa_uno_comp/SendProducts";
import SendProductPdf from "../../components/empresa_uno_comp/SenProductPdf";
import { ModalViewProductEmpresa } from "../../components/empresa_uno_comp/Modal_view_product_empresa";
import { ModalAddProduct } from "../../components/empresa_uno_comp/ModalAddProduct";
import { ProductModal } from "../../components/empresa_uno_comp/ProductModal";
import { ModalImportExcel } from "../../components/ModalImportarExcel";
import { returnCurrentDateTime, SelectBranchs, useProovedorData, useProveedorCompany } from "../../components";
import TablesMobile from "../../components/empresa/TablesMobile";
import SearchCompany from "./SearchCompany";
import { ImagenesGlobal } from "../../components/global/ImagenesGlobal";
import CallApi from "../../data/CallApi";
import TableMobile from "../../components/empresa/TableMobile";

export const Tienda = ({ sucursal_selected, obj_sucursal, companyID = 0, permisos, myRoll, showTable, setShowTable }) => {
	const [dataModal, setDataModal] = useState([]);
	const [products, setProducts] = useState([]);
	const [filteredProducts, setFilteredProducts] = useState([]);
	const [selectedRow, setSelectedRow] = useState({});
	const [loading, setLoading] = useState(true);
	const [isSendProductsOpen, setIsSendProductsOpen] = useState(false);
	const [isSendProductPdfOpen, setIsSendProductPdfOpen] = useState(false);
	const [menuAnchor, setMenuAnchor] = useState(null);
	const [modalOpen, setModalOpen] = useState(null);
	// const [isAddModalOpen, setIsAddModalOpen] = useState(false);
	// const [isEditModalOpen, setIsEditModalOpen] = useState(false);
	const [isImportOpen, setIsImportOpen] = useState(false);
	const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
	const [productEditModel, setProductEditModel] = useState({});
	const [limitContent, setLimitContent] = useState(30);
	const [currentSize, setCurrentSize] = useState(window.innerWidth);

	const filterRef = useRef([]);

	const { copyProduct, setCopyProduct, loadImageS, dbData } = useProovedorData() ?? [];
	const { returnCurrency } = useProveedorCompany() ?? [];
	const handleOpenImportModal = () => {
		setIsImportOpen(true);
	};

	const handleCloseImportModal = () => {
		setIsImportOpen(false);
	};

	useEffect(() => {
		fetchDataToModal();
	}, []);

	useEffect(() => {
		const handleResize = () => {
			setCurrentSize(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		// Cleanup function para quitar el listener cuando el componente se desmonte
		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	useEffect(() => {
		fetchProducts();
	}, [sucursal_selected]);

	const postBranch = (obj_sucursal ?? []).findIndex((obj) => obj?.key_branch == sucursal_selected);
	const tableSelected = `product_${companyID}#${postBranch}`;

	const fetchProducts = async () => {
		if (!dbData) return console.error("No fue posible conectarse a la bd");

		try {
			setLoading(true);

			const getListProducts = (await dbData.get('companies', tableSelected))?.Value ?? [];
			let productTokenV = (await dbData.get('validTokens', tableSelected))?.Value ?? 'no_one';
			
			const products_data = await CallApi({
				url: `api/company/product/list?key_branch=${sucursal_selected}&temp=${productTokenV}`
			});

			const extractedResult = products_data?.token_generated == productTokenV ? getListProducts : (products_data?.result ?? []);

			if (products_data?.token_generated) await dbData.put('validTokens', { id: tableSelected, Value: products_data?.token_generated });

			if (extractedResult.length > 0) await dbData.put('companies', { id: tableSelected, Value: extractedResult });

			setProducts(extractedResult);
			setFilteredProducts(extractedResult);
			filterRef.current = extractedResult;
		} catch (error) {
			console.error("Error:", error)
		} finally {
			setLoading(false);
		}
	};

	// async function forceReload(e) {
	// 	if (!dbData) return console.error("No fue posible conectarse a la bd");
	// 	const expirationName = 'reload_' + tableSelected;

	// 	let productExp = await dbData.get('expiration', expirationName);
	// 	const currentDT = returnCurrentDateTime();
	// 	let updateProduct = {
	// 		updateAttempts: false,
	// 		updateDT: false
	// 	};

	// 	if (productExp) {
	// 		const { lastUpdate, attempts } = productExp.Value;
	// 		const expirationDT = new Date(lastUpdate);
	// 		const newCurrentDT = new Date(currentDT);

	// 		expirationDT.setMinutes(expirationDT.getMinutes() + 30);

	// 		updateProduct = { //Falta
	// 			updateAttemps: newCurrentDT > expirationDT || attempts < 5 ? true : false,
	// 			updateDT: newCurrentDT > expirationDT ? true : false
	// 		}
	// 	} else {
	// 		updateProduct = {
	// 			updateAttempts: true,
	// 			updateDT: true
	// 		};
	// 	}

	// 	if (updateProduct) {
	// 		let newValue = {
	// 			lastUpdate: !productExp || updateProduct.updateDT ? currentDT : productExp.Value.lastUpdate,
	// 			attempts: updateProduct.updateDT && updateProduct.updateAttempts ? 1 : ((productExp ? productExp.Value.attempts : 0) + 1)
	// 		}

	// 		await dbData.put('expiration', { id: expirationName, Value: newValue });
	// 		fetchProducts(true);
	// 	}
	// 	else toast.info("Se agotaron los intentos para forzar la carga de productos")
	// }

	async function updatedProducts(type, product = {}) {
		if (!["add", "edit"].includes(type)) return toast.error("Tipo de modal indefinido...");

		let currentListProducts = [...products];

		if (type == "add") currentListProducts.unshift(product);
		if (type == "edit") currentListProducts = currentListProducts.map((obj) => obj?.key_product == product?.key_product ? product : obj);

		setProducts(currentListProducts);
		await dbData.put('companies', { id: tableSelected, Value: currentListProducts });
		closeModals();
	}

	const fetchDataToModal = async (reset = null, newObject = {}) => { //REHACER
		if (reset && !["category", "brand", "supplier"].includes(reset))
			return toast.info("No es posible cargar " + reset);

		if (!reset) {
			const response = await CallApi({
				url: `api/company/SupBraCat/list?key_branch=${sucursal_selected + (reset != null ? "&reset=" + reset : "")}`
			});

			if (!response) return toast.error("Error al obtener los datos para modal");

			setDataModal(response);
		} else {
			setDataModal((current_data) => ({
				...current_data,
				[reset]: [
					...current_data[reset],
					newObject
				]
			}));
		}
	};

	const debouncedSearch = useCallback(
		debounce((item) => {
			setDebouncedSearchTerm(item.target.value);
		}, 700),
		[]
	);

	const memoizedFilteredProducts = useMemo(() => {
		if (debouncedSearchTerm.trim() === "") {
			setLimitContent(30 > products.length ? products.length : 30);
			return products;
		}

		const searchLower = debouncedSearchTerm.toLowerCase();
		const resultFilter = products.filter((product) => {
			if (
				(product?.name && product?.name.toLowerCase().includes(searchLower)) ||
				(product.code && product.code.toLowerCase().includes(searchLower)) ||
				(product.category && product.category.toLowerCase().includes(searchLower))
			) {
				return true;
			}

			if (product.description && typeof product.description === "object") {
				const descEntries = Object.entries(product.description);
				for (const element of descEntries) {
					const [key, value] = element;
					if (
						key.toLowerCase().includes(searchLower) ||
						(value && value.toString().toLowerCase().includes(searchLower))
					) {
						return true;
					}
				}
			}
			return false;
		});

		setLimitContent(30 > resultFilter.length ? (resultFilter.length) : 30);

		filterRef.current = resultFilter;
		return resultFilter;
	}, [debouncedSearchTerm, products]);

	useEffect(() => {
		setFilteredProducts(memoizedFilteredProducts);
	}, [memoizedFilteredProducts]);

	const habilitarVistaProducto = async (product) => {
		const url = `api/company/product/view?key_branch=${sucursal_selected}&key_product=${product.key_product}`;
		const options = { method: "PUT" };
		const response = await ApiService.fetchData(url, options);

		if (response?.code != 200) return toast.error(response?.message ?? "Error al habilitar el producto");

		setProducts((prevProducts) =>
			prevProducts.map((item) =>
				item.key_product === product.key_product ? { ...item, selected: !item.selected } : item
			)
		);
		setFilteredProducts((prevFiltered) =>
			prevFiltered.map((item) =>
				item.key_product === product.key_product ? { ...item, selected: !item.selected } : item
			)
		);

		let currentListProducts = [...products];
		currentListProducts = currentListProducts.map((obj) => obj?.key_product == product?.key_product ? ({
			...product,
			selected: product?.selected ? false : true
		}) : obj);

		await dbData.put('companies', { id: tableSelected, Value: currentListProducts });

		toast.success(response.message);
	};

	const deleteProduct = async (keyProduct) => {
		const url = `api/company/product/delete?key_branch=${sucursal_selected}`;
		const body = {
			key_product: keyProduct,
		};
		const options = {
			method: "DELETE",
			body: JSON.stringify(body),
		};
		const response = await ApiService.fetchData(url, options);

		if (response?.code != 200) return toast.error(response?.message ?? "Error al eliminar el producto");
		
		let currentListProducts = [...products];
		const newList = (currentListProducts ?? []).filter((item) => item.key_product !== keyProduct);

		setProducts(newList);
		setFilteredProducts(newList);
		await dbData.put('companies', { id: tableSelected, Value: newList });

		toast.success(response?.message);
	};

	function copyobject(evento, object = {}) {
		evento.stopPropagation();
		setCopyProduct(object);
		toast.success("Copiado!", { autoClose: 1000 });
	}

	const getColumns = () => {
		const columns = [
			{
				field: "image",
				headerName: "Foto",
				sortable: false,
				flex: 1,
				renderCell: (params) => {
					if (!params?.row) return null;
					return (
						<div style={{ width: "90px", height: "90px", margin: "5px" }}>
							<ImagenesGlobal
								url={params.row?.images.length > 0 ? params.row.images[0] : null}
								alt={params.row?.name}
								style={{ width: "100%", height: "100%", objectFit: 'cover', objectPosition: 'center' }}
								key={params.row?.images.length > 0 ? params.row.images[0] : null}
								loadImageS={loadImageS}
								type={'picture'}
							/>
						</div>
					);
				},
			},
			{
				field: "code",
				headerName: "Código",
				width: 100,
				renderCell: (params) => {
					if (!params?.row) return null;
					return <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{params.row.code}</div>;
				},
			},
			{
				field: "name",
				headerName: "Nombre",
				flex: 1,
				renderCell: (params) => {
					if (!params?.row) return null;
					if (!params.row.description || typeof params.row.description !== "object") {
						return <span>No hay especificaciones</span>;
					}
					return <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{params.row?.name}</div>;
				},
			},
			{
				field: "stock",
				headerName: "Cantidad",
				align: "center",
				width: 100,
				headerAlign: "center",
				renderCell: (params) => {
					if (!params?.row) return null;
					return <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>{params.row.stock}</div>;
				},
			},
			{
				field: "price",
				headerName: "Precio",
				flex: 1,
				renderCell: (params) => {
					if (!params?.row) return null;
					return (
						<div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
							{returnCurrency(params.row.price)}
						</div>
					);
				},
			},
		];

		if (["G3R1", "S4A1"].includes(myRoll)) {
			columns.splice(3, 0, {
				field: "last_update",
				headerName: "Fecha",
				flex: 1,
			});

			columns.splice(5, 0, {
				field: "purchase_price",
				headerName: "Precio de compra",
				flex: 1,
				renderCell: (params) => {
					if (!params) {
						return "";
					}
					return returnCurrency(params.row.purchase_price);
				},
			});

			columns.splice(6, 0, {
				field: "benefit",
				headerName: "Beneficio",
				flex: 1,
				renderCell: (params) => {
					if (!params?.row) return "";
					const price = parseFloat(params.row.price) || 0;
					const purchasePrice = parseFloat(params.row.purchase_price) || 0;
					return returnCurrency((price - purchasePrice).toFixed(2));
				},
			});
		}

		columns.push({
			field: "actions",
			headerName: "Accion",
			align: "center",
			headerAlign: "center",
			renderCell: (params) => (
				<div style={{ display: 'flex', flexFlow: 'row wrap', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
					<button className="default-buttons" onClick={(event) => copyobject(event, params.row)}>
						<ContentCopyIcon sx={{ color: '#000' }} fontSize={"small"} />
					</button>
					<MuiIcon>
						{params.row.selected ? (
							<Tooltip title="Deshabilitar vista">
								<VisibilityOffRoundedIcon
									onClick={(event) => {
										event.stopPropagation();
										habilitarVistaProducto(params.row);
									}}
									fontSize={"small"}
									color={"primary"}
								/>
							</Tooltip>
						) : (
							<Tooltip title="Habilitar vista">
								<RemoveRedEyeRoundedIcon
									onClick={(event) => {
										event.stopPropagation();
										habilitarVistaProducto(params.row);
									}}
									fontSize={"small"}
									color={"primary"}
								/>
							</Tooltip>
						)}
					</MuiIcon>
					{
						permisos?.edit && (
							<Tooltip title={"Editar producto"}>
								<MuiIcon>
									<EditRoundedIcon
										fontSize={"small"}
										onClick={(event) => {
											event.stopPropagation();
											setProductEditModel(params.row);
											setModalOpen("edit");
										}}
									/>
								</MuiIcon>
							</Tooltip>
						)
					}
					{
						permisos?.deleteP && (
							<Tooltip title="Eliminar producto">
								<MuiIcon>
									<DeleteRoundedIcon
										onClick={(event) => {
											event.stopPropagation();
											deleteProduct(params.row.key_product);
										}}
										fontSize={"small"}
									/>
								</MuiIcon>
							</Tooltip>
						)
					}

				</div>
			),
			sortable: false,
		});

		return columns;
	};

	const handleView = (row) => {
		let product_selected = null;
		if (row?.other) product_selected = row.authCode;

		setSelectedRow(product_selected ?? row);
	};

	const handleViewGrid = (item) => {
		//change property name
		setSelectedRow(item);
	};

	function click_SendProduct() {
		if (obj_sucursal.length - 1 === 0) {
			toast.info("Para realizar un envío, es necesario contar con al menos dos sucursales activas");
			return;
		}

		setIsSendProductsOpen(true);
	}

	const prepareDataForGrid = (data) => {
		return data.map((item, index) => ({
			...item,
			id: item.key_product ?? `row-${index}`,
		}));
	};

	const dataWithIds = prepareDataForGrid(filteredProducts);

	const [currentDetail, setCurrentDetail] = useState(null);

	const buttonDetailProductMobile = (objs, index,) => {
		return (
			<>
				<button className="default-buttons show-details picaHuevos2000" id={`productMobile_${index}`} name="show-modal-mobile" style={{ position: 'relative' }}
					onClick={() => setCurrentDetail(index)}
				>
					<MoreHorizIcon
						style={{ fontSize: '30px' }}
						color="var(--theme-company)"
					/>
				</button>

				{
					currentDetail == index && (
						<div className="detail-mobile-products shadow-lvl4"
							style={{
								display: 'flex',
								top: '0px',
								right: 22,
								zIndex: 6
							}}
							ref={refModalMobile}
						>
							<h3 className='limited-text' style={{ fontSize: '1.2rem', fontWeight: 550, color: 'var(--theme-company)' }}>{objs?.name}</h3>

							<div>
								<h4>Fecha</h4>
								<span>{objs?.last_update}</span>
							</div>

							<div>
								<h4>Cantidad</h4>
								<span>{objs?.stock ?? 0}</span>
							</div>

							<div>
								<h4>Precio Compra</h4>
								<span>BS. {parseFloat(objs?.purchase_price).toFixed(2)}</span>
							</div>

							<div>
								<h4>Beneficio</h4>
								<span>BS. {(returnCurrency(objs?.price) - parseFloat(objs?.purchase_price ?? 0))}</span>
							</div>

							<div>
								<h4>Precio de Venta</h4>
								<span>BS. {returnCurrency(objs?.price)}</span>
							</div>

							<div>
								<h4>Accion</h4>
								<span style={{ display: 'flex', flexFlow: 'row nowrap', width: '100%', justifyContent: 'center', alignItems: 'center' }}>
									<button className="default-buttons" onClick={(event) => copyobject(event, objs)}>
										<ContentCopyIcon sx={{ color: '#000' }} fontSize={"small"} />
									</button>
									<MuiIcon>
										{objs?.selected ? (
											<Tooltip title="Deshabilitar vista">
												<VisibilityOffRoundedIcon
													onClick={(event) => {
														event.stopPropagation();
														habilitarVistaProducto(objs);
													}}
													style={{ fontSize: '30px' }}
													color={"primary"}
												/>
											</Tooltip>
										) : (
											<Tooltip title="Habilitar vista">
												<RemoveRedEyeRoundedIcon
													onClick={(event) => {
														event.stopPropagation();
														habilitarVistaProducto(objs);
													}}
													style={{ fontSize: '30px' }}
													color={"primary"}
												/>
											</Tooltip>
										)}
									</MuiIcon>
									{
										permisos?.edit && (
											<Tooltip title={"Editar producto"}>
												<MuiIcon>
													<EditRoundedIcon
														style={{ fontSize: '30px' }}
														onClick={(event) => {
															event.stopPropagation();
															setProductEditModel(objs);
															setModalOpen("edit");
														}}
													/>
												</MuiIcon>
											</Tooltip>
										)
									}
									{
										permisos?.deleteP && (
											<Tooltip title="Eliminar producto">
												<MuiIcon>
													<DeleteRoundedIcon
														onClick={(event) => {
															event.stopPropagation();
															deleteProduct(objs?.key_product ?? null);
														}}
														style={{ fontSize: '30px', color: 'var(--theme-company)' }}
													/>
												</MuiIcon>
											</Tooltip>
										)
									}
								</span>
							</div>
						</div>
					)
				}
			</>
		);
	}

	const refModalMobile = useRef(null);

	const handleScroll = throttle(() => {
		const getCompanyView = document.getElementById("content-scroll");
		if (!getCompanyView) return console.error("No puedes ingresar sin obtener el elemento main");

		const { scrollTop, clientHeight, scrollHeight } = getCompanyView;

		if (scrollTop + clientHeight >= scrollHeight - 100) setLimitContent((current_val) => {
			const currentLengtFilter = filterRef.current.length;
			return (current_val + 30) > currentLengtFilter ? (currentLengtFilter) : (current_val + 30)
		});
	}, 500);

	const handleViewProducts = () => {
		setShowTable(!showTable);
	}

	function closeModals() {
		setModalOpen(null);
		setProductEditModel({});
	}

	useEffect(() => {
		function closeMiniModal(event) {
			if (refModalMobile.current && !refModalMobile.current.contains(event.target) && window.innerWidth < 500) setCurrentDetail(null);
		}

		const mainContent = document.getElementById("main-page");
		const getCompanyView = document.getElementById("content-scroll");

		if (getCompanyView) getCompanyView.addEventListener('scroll', handleScroll);
		if (mainContent) mainContent.addEventListener("click", closeMiniModal)

		return () => {
			if (getCompanyView) getCompanyView.removeEventListener('scroll', handleScroll);
			if (mainContent) mainContent.removeEventListener("click", closeMiniModal)
		};
	}, []);

	const listPorductsLimited = filteredProducts.slice(0, limitContent);

	return (
		<>
			<div className="functionality-container">
				<div className="product-reverse">
					<FormControl size="small" sx={{ minWidth: 120, maxWidth: 200 }}>
						<SelectBranchs />
					</FormControl>

					<button
						style={{ textTransform: 'uppercase', backgroundColor: '#E65100 !important' }}
						className="buttons-company-default"
						onClick={handleViewProducts}
					>
						{showTable ? "Catálogo" : "Lista"}
					</button>
				</div>

				<SearchCompany theme={'var(--theme-company)'} setValor={debouncedSearch} placeholder="Productos" />

				<div className="content-btn-add add-store">
					<div style={{ display: "inline-block" }}>
						<MuiButton
							className="buttons-company-default"
							variant="contained"
							onClick={(e) => setMenuAnchor(e.currentTarget)}
							endIcon={<ExpandMore />}>
							Opciones
						</MuiButton>
						<Menu anchorEl={menuAnchor} open={Boolean(menuAnchor)} onClose={() => setMenuAnchor(null)}>
							{permisos?.send && (
								<MenuItem
									onClick={() => {
										click_SendProduct();
										setMenuAnchor(null);
									}}>
									<LocalShipping sx={{ marginRight: 1 }} /> Enviar
								</MenuItem>
							)}
							<MenuItem onClick={handleOpenImportModal}>
								<UploadFile sx={{ marginRight: 1 }} /> Importar
							</MenuItem>
							{/* <MenuItem onClick={forceReload}>
								<RefreshIcon sx={{ marginRight: 1 }} />
								Forzar Carga
							</MenuItem>  */}
							<MenuItem
								onClick={() => {
									setIsSendProductPdfOpen(true);
									setMenuAnchor(null);
								}}>
								<PictureAsPdf sx={{ marginRight: 1 }} /> PDF
							</MenuItem>
						</Menu>
					</div>
					{permisos?.insert && (
						<button className="buttons-company-default" onClick={() => setModalOpen("add")}>
							<AddCircleOutlineIcon style={{ fontSize: '30px' }} />
							<span>Nuevo Producto</span>
						</button>
					)}
				</div>
			</div>

			<div className="datatable-container table-product" style={{ marginTop: '10px' }}>
				{loading ? (
					<Preloader />
				) : showTable ? (
					currentSize > 480 ? (
						<div className="table-view-pc">
							<Box sx={{ width: "100%", height: "calc(100vh - 200px)" }}>
								<DataGrid
									density={"comfortable"}
									rows={dataWithIds}
									columns={getColumns()}
									initialState={{
										pagination: {
											paginationModel: { pageSize: 10, page: 0 },
										},
									}}
									pageSizeOptions={[5, 10, 25, 50]}
									pagination
									localeText={{
										MuiTablePagination: {
											labelRowsPerPage: "Filas por pagina:",
											labelDisplayedRows: ({ from, to, count }) =>
												`${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
										},
									}}
									disableRowSelectionOnClick
									hideFooterSelectedRowCount
									checkboxSelection={false}
									rowSelection={false}
									onRowClick={(params) => handleView(params.row)}
									slots={{
										noRowsOverlay: () => (
											<Box
												sx={{
													display: "flex",
													flexDirection: "column",
													alignItems: "center",
													justifyContent: "center",
													height: "100%",
												}}>
												<VisibilityOffRoundedIcon
													sx={{ fontSize: 40, color: "text.secondary", mb: 1 }}
												/>
												<Typography variant="h6" color="textSecondary">
													No hay productos disponibles
												</Typography>
											</Box>
										),
									}}
									sx={{
										"& .MuiDataGrid-columnHeader": {
											backgroundColor: 'var(--theme-company)',
											color: "white",
											fontWeight: "bold",
										},
										'& .MuiDataGrid-checkboxInput': {
											display: 'none !important',
										},
										'& .MuiDataGrid-columnHeader--checkbox': {
											display: 'none !important',
										}
									}}
								/>
							</Box>
						</div>
					) : (
						<TableMobile
							loadImageS={loadImageS}
							itsCompany={true}
							filteredData={(listPorductsLimited ?? []).map((obj) => ({
								img: obj?.images[0],
								title: obj?.name,
								other: 'CÓDIGO: ' + obj?.code,
								texto: returnCurrency(obj?.price),
								authCode: obj
							}))}
							profile={true}
							type="picture"
							functionEspecial={buttonDetailProductMobile}
							mode="reportes"
							showDetail={handleView}
						/>
					)
				) : (
					<div className="container-store-catalog" style={{ overflow: 'hidden', maxHeight: '100%' }}>
						{
							(listPorductsLimited ?? []).map((objs, index) => (
								<div className="cards-catalog shadow-lvl4" onClick={() => handleViewGrid(objs)} key={objs?.key_product}>
									<div className="profile-product-catalog">
										<ImagenesGlobal
											url={objs?.images[0] ?? null}
											key={objs?.images[0] ?? null}
											loadImageS={loadImageS}
											type={'picture'}
										/>
									</div>

									<div style={{ padding: '0px 10px' }}>
										<div
											style={{
												display: 'flex',
												gap: '5px',
												justifyContent: 'space-between',
												alignItems: 'center',
												whiteSpace: 'nowrap',
												overflow: 'hidden',
												textOverflow: 'ellipsis',
												width: '100%',
												fontSize: 'clamp(14px, 4vw, 16px)' // Esto ajusta el tamaño si es necesario
											}}
										>
											<span
												style={{
													fontWeight: 500,
													color: '#000',
													overflow: 'hidden',
													textOverflow: 'ellipsis',
													whiteSpace: 'nowrap',
													flex: 1,
													minWidth: 0
												}}
											>
												{objs?.code}
											</span>
											<span
												style={{
													fontWeight: 500,
													color: 'var(--verde)',
													whiteSpace: 'nowrap',
													flexShrink: 0
												}}
											>
												{returnCurrency(objs?.price)}
											</span>
										</div>
										<span className="limited-text" style={{ color: '#000' }}>{objs?.name}</span>
									</div>
								</div>
							))
						}
					</div>
				)}
			</div>

			{isSendProductsOpen && (
				<SendProducts
					isOpen={isSendProductsOpen}
					onClose={() => setIsSendProductsOpen(false)}
					products={products}
					list_suc={
						sucursal_selected
							? obj_sucursal.filter((obj_suc) => obj_suc.key_branch !== sucursal_selected)
							: []
					}
					auth={localStorage.getItem("token")}
					key_branch={sucursal_selected}
					refresh={fetchProducts}
				/>
			)}
			{isSendProductPdfOpen && (
				<SendProductPdf
					isOpen={isSendProductPdfOpen}
					onClose={() => setIsSendProductPdfOpen(false)}
					obj_product={products}
					selectedSucursal={sucursal_selected}
					branches={obj_sucursal}
					convertPrice={returnCurrency}
				/>
			)}

			{
				<ProductModal //Agregar, Editar
					stateModal={modalOpen && ["add", "edit"].includes(modalOpen)}
					copiedObject={copyProduct}
					productSelected={productEditModel ?? {}}
					reload={fetchDataToModal}
					dataModal={dataModal}
					current_branch={sucursal_selected}
					onClose={closeModals}
					theme={'var(--theme-company)'}
					modal_type={modalOpen}
					updateProduct={updatedProducts}
				/>
			}

			<ModalViewProductEmpresa
				canViewSwitch={permisos?.detail}
				onClose={() => setSelectedRow(({}))}
				product={selectedRow}
				isPrivileged={['G3R1', 'S4A1'].includes(myRoll)}
				loadImageS={loadImageS}
				convertPrice={returnCurrency}
			/>
			<ModalImportExcel
				isOpen={isImportOpen}
				reload_product={fetchProducts}
				onClose={handleCloseImportModal}
				current_branch={sucursal_selected}
				refreshProducts={fetchProducts}
			/>
		</>
	);
};